import { createFormAction } from 'redux-form-saga'

const SELECT_REQUEST = 'schedule-delays/select/request'
const SELECT_SUCCESS = 'schedule-delays/select/success'
const SELECT_FAILURE = 'schedule-delays/select/failure'

const INSERT = createFormAction('SCHEDULE_DELAYS_INSERT')

export { SELECT_REQUEST, SELECT_SUCCESS, SELECT_FAILURE, INSERT }
